import React, { useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import pieDiagram from "./pieDiagram";
import { getPathogenicitiesPerArticle } from "../../../state/selectors/PubmedUserEntries.selectors";
import tailwindColors from "../../../../../tailwind.colors";

function PathogenicityPieChart({ pathogenicities, className, size }) {
  const chart = useRef(null);
  const svgRef = useRef(null);
  const containerRef = useRef(null);
  const items = useMemo(() => {
    const gray = tailwindColors.blueGray["700"];
    const totalCount = pathogenicities.reduce((a, x) => a + x.times, 0);
    return pathogenicities.length
      ? pathogenicities.map((x) => ({
          value: x.times,
          color: x.color,
          total: totalCount,
        }))
      : [{ color: gray, value: 1, total: 1 }];
  }, [pathogenicities]);

  useEffect(() => {
    const chartConf = { element: svgRef.current, arcWidth: 3 };
    if (!chart.current) chart.current = pieDiagram(chartConf);
    chart.current.setDimensions(size, size);
  }, []);

  useEffect(() => {
    if (!chart.current) return;
    chart.current.setData(items);
  }, [items]);

  useEffect(() => {
    return () => {
      if (chart.current) chart.current = null;
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`${className} tw-flex tw-items-center tw-justify-center`}
    >
      <svg ref={svgRef} className="tw-h-auto tw-overflow-visible tw-block" />
    </div>
  );
}

PathogenicityPieChart.propTypes = {
  pathogenicities: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
  size: PropTypes.number,
};

PathogenicityPieChart.defaultProps = {
  pathogenicities: [],
  className: "tw-w-6 tw-h-6",
  size: 16,
};

const mapStateToProps = (state, props) => {
  const { pubmedId, sourceEntity } = props;
  const sourceId = sourceEntity?.id;
  const pathoEntries = getPathogenicitiesPerArticle(state) || [];
  const allEntries = (pathoEntries || {})[pubmedId] || [];
  const pathogenicities = allEntries.filter((x) => x.variantId === sourceId);

  return { pathogenicities };
};

export default React.memo(connect(mapStateToProps, {})(PathogenicityPieChart));
